module.exports = __webpack_public_path__ + "img/card_ip_stipulation51.ac0484b9.svg";